import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AdminDashboard from './admin/AdminDashboard';
import AdminMaintenance from './admin/AdminMaintenance';
import AdminSupplies from './admin/AdminSupplies';
import AdminAMC from './admin/AdminAMC';
import AdminNotices from './admin/AdminNotices';
import AdminVendors from './admin/AdminVendors';
import AdminVisitors from './admin/AdminVisitors';
import AdminAssets from './admin/AdminAssets';
import AdminKPI from './admin/AdminKPI';

export default function Admin() {
  return (
    <div data-testid="admin-page">
      <Routes>
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<AdminDashboard />} />
        <Route path="maintenance" element={<AdminMaintenance />} />
        <Route path="supplies" element={<AdminSupplies />} />
        <Route path="amc" element={<AdminAMC />} />
        <Route path="notices" element={<AdminNotices />} />
        <Route path="vendors" element={<AdminVendors />} />
        <Route path="visitors" element={<AdminVisitors />} />
        <Route path="assets" element={<AdminAssets />} />
        <Route path="kpi" element={<AdminKPI />} />
      </Routes>
    </div>
  );
}
